

// PictureGround.js =>

// URL있을 때 민트색 이고, 꺾쇠(링크연결)부분 보인다.
// , 없을 때 진회색 이고, 꺾쇠(링크연결)부분 안보인다.

export default props=>{
    if(!props.me) return <></>;
    let direction="";

    if (props.x > 50) direction = "on-right";
    
const jsx=(<div className="">
    <style jsx>{`

.label-container{
    position: absolute;
    top: calc(${props.y}% - 15px);
    left: calc(${props.x}% - 15px);

    height: 30px;
    line-height: 30px;
}


.label-container.on-right{
    position: absolute;
    right: calc(100% - ${props.x}% - 15px);
    left: auto;
}


/* {props.me.url ? '#55d5ce' : '#343a40'} */

.dark-label > .f2, 
.dark-label > .f3, 
.dark-label > .f31 
{
    background-color: #343a40;
    /* border-color:#343a40; */
}

.dark-label > .f1{
    border-right-color: #343a40;
}

.dark-label > .f11{
    border-left-color: #343a40;
}

.f1, .f11{
    width: 0;
    height:0;
    border-top:solid 15px transparent;
    border-right:solid 15px #55d5ce;
    border-bottom:solid 15px transparent;
    border-left:solid 15px transparent;
}

.f2{
    margin: 0;
    border: 0;
    padding: 0 15px;

    background-color: #55d5ce;
    color: white;

    height: 30px;
    line-height: 30px;
    vertical-align: top;

    font-size: 12px;
}
.f2 a{
    color: white;
}

.f3, .f31{
    background-color: #55d5ce;;
    vertical-align: top;
    margin: 0;
    border: 0;
    padding: 0;
    height: 30px;
    line-height: 30px;
}

.f3 img, .f31 img{
    padding: 3px;
}

.f11{
    display:inline-block;
    width: 0;
    height:0;
    border-top:solid 15px transparent;
    border-right:solid 15px transparent;
    border-bottom:solid 15px transparent;
    border-left:solid 15px #55d5ce;
}

.f11, .f3{
    display:none;
}

.f1, .f31{
    display:inline-block;
}


.on-right .f1, .on-right .f31{
    display:none;
}

.on-right .f11, .on-right .f3{
    display:inline-block;
}



.on-right .next{
    transform: scaleX(-1);
}
`}</style>
    {/* !!{props.me.url}@@{props.me.url ? 'block' : 'none'}## */}
    <div className={"label-container " + direction + (props.me.url ? '' : ' dark-label')} style={{ display: props.d }}>

    {/* <div className={"label-container " + direction} style={{ display: props.d}}> */}
        <div className="dib f1" />
        <div className="dib f3">
            <img className="next" style={{ display: props.me.url ? 'inline-block':'none'}} src="/assets/images/next.svg" />
            {/* <img className="close" src="/assets/images/x_white.svg" /> */}
        </div>
        <div className="dib f2">
            {(props.me.url ?
                <a href={props.me.url} target="_blank">{props.me.brand.name}</a> :
                props.me.brand.name
            )}
        </div>
        <div className="dib f11" />
        <div className="dib f31">
            {/* <img className="close" src="/assets/images/x_white.svg" /> */}
            <img className="next" style={{ display: props.me.url ? 'inline-block' : 'none' }} src="/assets/images/next.svg" />
        </div>
    </div>


</div>);
return jsx;
}